module.exports = __webpack_public_path__ + "static/media/newsletter-may-2021-breaking-the-fast.21d9a23f.jpg";